<template>
    <el-dialog title="" :visible.sync="fileVisible" width="800px" class="dialogWarp" @closed="offmodalFn" :destroy-on-close="true"
        :close-on-click-modal='false' :append-to-body="true">
        <div class="singupdialogcenter">
            <div class="textbox" @click="downloadFileFn">
                <span>1.生成并下载入会申请表</span>
                <i class="el-icon-download iconbox" />
            </div>
            <div class="singupForm">
                <el-form :model="dataForm" ref="dataForm" :rules='formRules' label-width="120px" class="demo-dynamic" label-position='top'>
                    <div class="applicationBox">
                        <el-form-item label="2.上传《入会申请表》加盖公章" prop="application">
                            <el-upload id="imgupload" accept=".jpg,.png,.jpeg" ref="imgupload" list-type="picture-card" :on-success="handleAvatarSuccess"
                                :on-remove="handleRemove" :action="actionUrl" :headers="header" :limit="1" :file-list="imgfileList"
                                :before-upload="beforeAvatarUpload">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                        <div class="titleBox">（请上传竖版png、jpg、jpeg格式图片）</div>
                    </div>
                    <div class="applicationBox">
                        <el-form-item label="3.上传营业执照或法人登记证书扫描件（带年检章）" prop="materials1">
                            <el-upload accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="secondSuccessFn" :on-remove="secondRemoveFn" :action="actionUrl"
                                :headers="header" :file-list="secondfileList">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                        <div class="titleBox1">（请上传竖版png、jpg、jpeg格式图片）</div>
                    </div>
                    <div class="applicationBox">
                        <el-form-item label="4.上传《人力资源服务许可证书》或相关许可证扫描件（带年检章）" prop="materials2">
                            <el-upload accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="thirdSuccessFn" :on-remove="thirdRemoveFn" :action="actionUrl"
                                :headers="header" :file-list="thirdfileList">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                        <div class="titleBox2">（请上传竖版png、jpg、jpeg格式图片）</div>
                    </div>
                    <!-- <el-form-item label="3.上传营业执照或法人登记证书扫描件（带年检章）" prop="materials1">
                        <el-upload accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="secondSuccessFn" :on-remove="secondRemoveFn" :action="actionUrl"
                            :headers="header" :file-list="secondfileList">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item> -->
                    <!-- <el-form-item label="4.上传《人力资源服务许可证书》或相关许可证扫描件（带年检章）" prop="materials2">
                        <el-upload accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="thirdSuccessFn" :on-remove="thirdRemoveFn" :action="actionUrl"
                            :headers="header" :file-list="thirdfileList">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item> -->
                    <div class="formBtnBox">
                        <el-button type="primary" @click="submitForm('dataForm')" class="submitBtn" :loading="isloading" v-if="!fileFlag">提交审核</el-button>
                        <el-button type="primary" @click="submitForm('dataForm')" class="submitBtn" :loading="isloading" v-else>提交并进入下一步</el-button>
                        <el-button @click="offmodalFn" class="cancelBtn">返回</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
    props: ['isShow', 'userId', 'formObj'],
    data() {
        return {
            fileVisible: true,
            actionUrl: process.env.VUE_APP_GATEWAY + '/upload/addfile',
            header: null,
            imgfileList: [],
            secondfileList: [],
            thirdfileList: [],
            // 报名表单
            dataForm: {
                application: '',
                materials1: '',
                materials2: '',
            },
            formRules: {
                application: [
                    { required: true, message: '不能为空', trigger: 'change' }
                ],
                materials1: [
                    { required: true, message: '不能为空', trigger: 'change' }
                ],
            },
            isloading: false,
            fileFlag: false,
        }
    },

    mounted() {
        // if (this.formObj) {
        //     // 图片处理
        //     let imglist = [], materialslist1 = [], materialslist2 = [];
        //     if (this.formObj.application) {
        //         imglist = this.formObj.application.split(',');
        //         imglist = imglist.map((imgSrc, index) => {
        //             return {
        //                 url: srcUrl + imgSrc,
        //                 uid: index,
        //                 name: imgSrc
        //             };
        //         });
        //     }
        //     if (this.formObj.materials1) {
        //         materialslist1 = this.formObj.materials1.split(',');
        //         materialslist1 = materialslist1.map((Src, index) => {
        //             return {
        //                 url: srcUrl + Src,
        //                 uid: index,
        //                 name: Src
        //             };
        //         });
        //     }
        //     if (this.formObj.materials2) {
        //         materialslist2 = this.formObj.materials2.split(',');
        //         materialslist2 = materialslist2.map((Src, index) => {
        //             return {
        //                 url: srcUrl + Src,
        //                 uid: index,
        //                 name: Src
        //             };
        //         });
        //     }
        //     this.imgfileList = imglist;
        //     this.secondfileList = materialslist1;
        //     this.thirdfileList = materialslist2;
        //     this.dataForm = this.formObj
        //     // 隐藏上传按钮
        //     this.$nextTick(() => {
        //         if (this.imgfileList.length > 0) {
        //             this.$refs.imgupload.$el.firstChild.nextSibling.style.display = 'none'
        //         }
        //     })
        // }
    },
    methods: {
        downloadFileFn() {
            httpService.uploadApplyMem(this.userId).then(res => {
                if (res.code == 200) {
                    let url = res.result;
                    let Docurl = `http:${
                        process.env.VUE_APP_WZ
                        }${"/upload/download?session="}${url}${"&fileName="}${"入会申请表"}`;

                    let a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style.display = "none";
                    a.setAttribute("download", "");
                    a.setAttribute("target", "_self");
                    a.setAttribute("href", Docurl);
                    a.click();
                }
            })
        },
        // 报名表单
        submitForm(formName) {
            // this.$refs[formName].validate((valid) => {
            //     if (valid) {

            let application, applyDataUrl1 = [], applyDataUrl2 = []
            if (this.imgfileList.length != 0) {
                this.imgfileList.forEach(item => {
                    if (item.response) {
                        return application = item.response.result
                    } else {
                        return application = item.name
                    }
                })
            }

            if (this.secondfileList.length != 0) {
                this.secondfileList.map(item => {
                    if (item.response) {
                        return applyDataUrl1.push(item.response.result)
                    }
                    if (item.response) {
                        return applyDataUrl1.push(item.response.result)
                    } else {
                        return applyDataUrl1.push(item.name)
                    }
                })
            }
            if (this.thirdfileList.length != 0) {
                this.thirdfileList.map(item => {
                    if (item.response) {
                        return applyDataUrl2.push(item.response.result)
                    } else {
                        return applyDataUrl2.push(item.name)
                    }
                })
            }
            if (!application || applyDataUrl1.length == 0) {
                this.$message.error('请按要求上传所需文件图片');
                return
            } else {
                this.isloading = true
                let data = {
                    audit: 0,//审核
                    application,
                    corpInfoId: this.formObj.corpInfoId,
                    userId: this.userId,
                    materials1: applyDataUrl1.join(','),
                    materials2: applyDataUrl2.join(',')
                }
                // console.log(data);
                // return
                httpService.addApply(data).then(res => {
                    if (res) {
                        this.isloading = false
                        if (res.code == 200) {
                            this.$message({
                                message: '提交审核成功',
                                type: 'success'
                            });
                            // this.$emit('offSecondModal', res, true)
                            if (this.fileFlag) {
                                setTimeout(() => {
                                    sessionStorage.setItem('clickMenu', '能力指数测评')
                                    this.$router.push('/assessment-institutions');
                                }, 1000)

                            } else {
                                this.$emit('offSecondModal', res, true)
                            }
                            this.$emit('update:isShow', false)
                            if (!this.isCustom) this.$destroy() // 销毁当前组件
                        } else {
                            this.$message.error(res.message);
                        }
                    }
                })
            }
            // } else {
            //     return false;
            // }
            // });
        },
        // 关闭表单
        offmodalFn() {
            // this.$emit('offshowModal', false, this.dataForm)
            this.$emit('update:isShow', false)
            if (!this.isCustom) this.$destroy() // 销毁当前组件
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error('上传图片只能是png、jpg、jpeg格式!');
            }
            // if (!isLt2M) {
            //   this.$message.error('上传头像图片大小不能超过 2MB!');
            // }
            return isJPG;
        },
        // 图片上传
        handleAvatarSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.imgfileList = fileList
                // this.ruleForm.titleImgUrl = res.result
                if (this.imgfileList.length > 0) {
                    this.$refs.imgupload.$el.firstChild.nextSibling.style.display = 'none'
                    // imgupload
                }
            }
            // this.imageUrl = URL.createObjectURL(file.raw);
        },
        // 删除
        handleRemove(file, fileList) {
            this.imgfileList = []
            if (this.imgfileList.length == 0) {
                this.$refs.imgupload.$el.firstChild.nextSibling.style.display = 'inline-block'
            }
        },
        // 第二个上传
        secondSuccessFn(res, file, fileList) {
            if (res.code == 200) {
                this.secondfileList = fileList
            }
        },
        secondRemoveFn(file, fileList) {
            this.secondfileList = fileList
        },
        // 第三个上传
        thirdSuccessFn(res, file, fileList) {
            if (res.code == 200) {
                this.thirdfileList = fileList
                this.fileFlag = true
            }

        },
        thirdRemoveFn(file, fileList) {
            this.thirdfileList = fileList
        },
    }

}
</script>
<style lang="less" scoped>
// 课程相关
.dialogWarp {
	/deep/.singupdialogcenter {
		padding: 17px 40px 0px 40px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		.textbox {
			text-align: left;
			font-size: 16px;
			line-height: 21px;
			color: #333333;
			cursor: pointer;
			span,
			.iconbox {
				color: #448df7;
				cursor: pointer;
			}
			.iconbox {
				margin-left: 4px;
			}
		}

		.singupForm {
			width: 100%;
			.singupInfobox {
				padding-bottom: 32px;
				border-bottom: 1px solid #dddddd;
				margin-bottom: 20px;
				padding: 0 172px;

				.header {
					margin-bottom: 12px;
					.education {
						font-size: 16px;
						line-height: 54px;
						color: #999999;
					}
				}
				.btnwarp {
					font-size: 16px;
					line-height: 54px;
					display: flex;
					flex-direction: row;
					justify-content: center;

					.icon {
						margin-right: 5px;
					}
					.addbtn {
						color: #0083ff;
						margin: 0 20px;
						cursor: pointer;
					}
					.deletebtn {
						color: #ff3c3c;
						margin: 0 20px;
						cursor: pointer;
					}
				}
			}
			.formBtnBox {
				display: flex;
				fill-opacity: row;
				justify-content: center;
				.submitBtn {
					width: 152px;
					height: 40px;
					background: #349cff;
					margin: 0 20px;
				}

				.cancelBtn {
					width: 152px;
					height: 40px;
					border: 1px solid #a6a9b7;
					border-radius: 5px;
					margin: 0 20px;
				}
			}
			.applicationBox {
				position: relative;
				.titleBox {
					position: absolute;
					top: 10px;
					left: 200px;
					color: red;
				}
                .titleBox1{
                    position: absolute;
					top: 10px;
					left: 318px;
					color: red;
                }
                .titleBox2{
                    position: absolute;
					top: 10px;
					left: 405px;
					color: red;
                }
			}
		}
	}
}
</style>


